import React, {PropTypes} from 'react';
import classNames from 'classnames';
import CartVirtualEntryBowlerListContainer from './CartVirtualEntryBowlerListContainer.jsx';
import VirtualEntryPaymentLogContainer from './VirtualEntryPaymentLogContainer.jsx';

const CartVirtualEntry = ({
  zindexvalue,
  balanceDue,
  editing,
  selected,
  showPaymentLog,
  virtualEventId,
  virtualEventName,
  cartRosterId,
  totalEntries,
  onManageRosterClick,
  onSelectChecked,
  rosterComplete,
  virtualEntry
}) => (
  <div>
    <div
      className={classNames(
        "list-group-item-labeled",
        {"highlight animated flipInX": editing || showPaymentLog},
        {'bg-warning': balanceDue}
      )}
      style={{position: 'relative', zIndex: zindexvalue}}>
      <div className="list-group-item-labeled-child custom-checkbox-container"
        style={{width: 25}}>
        <input
          type="checkbox"
          id={`entry-${virtualEventId}`}
          disabled={!balanceDue}
          checked={selected}
          onChange={() => onSelectChecked(cartRosterId)}
        />
        <label
          htmlFor={`entry-${virtualEventId}`} />
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 740}}>
        <span>{'Virtual Event'}</span>
        <span>{virtualEventName}</span>
      </div>
      <div className={classNames(
          'list-group-item-labeled-child',
          {'bg-danger': balanceDue}
        )}
        style={{width: 110}} />
      <div
        style={{width: 150}}
        className={classNames(
          'list-group-item-labeled-child',
          {'bg-info': !(rosterComplete && (virtualEntry ? virtualEntry.rosterComplete : true)) }
        )}>
        <button
          className="btn btn-link"
          type="button"
          onClick={() => onManageRosterClick(cartRosterId, virtualEventId, totalEntries)}
        >{'Manage Bowlers'}</button>
      </div>
    </div>
    {editing
      ? <CartVirtualEntryBowlerListContainer zindexvalue={zindexvalue} />
      : null
    }
    {showPaymentLog
      ? <VirtualEntryPaymentLogContainer />
      : null
    }
  </div>
);

CartVirtualEntry.propTypes = {
  zindexvalue: PropTypes.number,
  balanceDue: PropTypes.number,
  editing: PropTypes.bool,
  selected: PropTypes.bool,
  showPaymentLog: PropTypes.bool,
  virtualEventId: PropTypes.string.isRequired,
  virtualEventName: PropTypes.string.isRequired,
  cartRosterId: PropTypes.string.isRequired,
  totalEntries: PropTypes.number.isRequired,
  onManageRosterClick: PropTypes.func,
  onPaymentLogClick: PropTypes.func,
  onSelectChecked: PropTypes.func,
  rosterComplete: PropTypes.bool,
  virtualEntry: PropTypes.object
};

CartVirtualEntry.defaultProps = {
  balanceDue: 0,
  rosterComplete: false
};

export default CartVirtualEntry;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CartVirtualEntry.jsx